import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Button2 from 'components/buttons/Button2/Button2';
import { LOGIN_FORM_TYPES } from 'constants/Login';
import AuthenticationLayout from 'components/templates/AuthenticationLayout/AuthenticationLayout';
import _get from 'lodash/get';
import { useSelector, useDispatch } from 'react-redux';
import Message2 from 'components/messages/Message2';
import SignIn from './components/SignIn/SignIn';
import Recover from './components/Recover/Recover';

const FormContainer = ({
  formType,
  handleFormTypeChange,
}) => {
  const { formatMessage: t } = useIntl();

  const dispatch = useDispatch();

  const resetRecoverPassword = () => dispatch({
    type: 'RECOVER_PASSWORD',
    status: null,
  });

  let RedirectionButton = null;
  let Form = null;
  let title = null;
  let subtitle = null;
  let Message = null;

  /* Reset messages when switching form or quitting window */
  /* ----------------------------------------------------- */

  useEffect(() => {
    window.addEventListener('beforeunload', resetRecoverPassword);
    return () => {
      window.removeEventListener('beforeunload', resetRecoverPassword);
    };
  }, []);

  /* 2️⃣ Recover password */
  /* ------------------- */
  const recoverPassword = useSelector((state) => _get(state, 'auth.recoverPassword', null));

  /* ✅ Success */
  /* ---------- */

  if (recoverPassword === 'GET_LINK') {
    Message = (
      <Message2
        type="success"
        onClose={resetRecoverPassword}
        title={t({ id: 'message.title.sendInstructions' })}
      >
        {t({ id: 'message.description.sendInstructions' })}
      </Message2>
    );
  }

  if (recoverPassword === 'UPDATED') {
    Message = (
      <Message2
        type="success"
        onClose={resetRecoverPassword}
        title={t({ id: 'message.title.recoveredPassword' })}
      >
        {t({ id: 'message.description.recoveredPassword' })}
      </Message2>
    );
  }

  /* ---------------------------------------------- */
  switch (formType) {
    case LOGIN_FORM_TYPES.SIGNIN:
      Form = <SignIn handleFormTypeChange={handleFormTypeChange} />;
      title = t({ id: 'title.accesYourSpace' });
      subtitle = t({ id: 'subtitle.signIn' });
      break;

    case LOGIN_FORM_TYPES.FORGOT_PASSWORD:
      RedirectionButton = (
        <Button2 type="primaryOutline" size="small" onClick={() => handleFormTypeChange(LOGIN_FORM_TYPES.SIGNIN)}>
          {t({ id: 'button.login' })}
        </Button2>
      );
      title = t({ id: 'title.resetPassword' });
      subtitle = t({ id: 'subtitle.resetPassword' });
      Form = <Recover handleFormTypeChange={handleFormTypeChange} />;
      break;

    default:
      break;
  }

  return (
    <AuthenticationLayout
      title={title}
      subtitle={subtitle}
      Message={Message}
      RedirectionButton={RedirectionButton}
    >
      {Form}
    </AuthenticationLayout>
  );
};

FormContainer.propTypes = {
  formType: PropTypes.string,
  handleFormTypeChange: PropTypes.func,
};

FormContainer.defaultProps = {
  formType: LOGIN_FORM_TYPES.SIGNIN,
  handleFormTypeChange: () => {},
};

module.exports = FormContainer;



// WEBPACK FOOTER //
// ./routes/login/components/cpm_manager/FormContainer.jsx